import { useEffect, useRef } from 'react';
import "../assets/styles/banner.css";

export default function Banner() {
    const videoRef = useRef(null);
    const overlayRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        const overlay = overlayRef.current;

        const handleCanPlay = () => {
            if (video && overlay) {
                video.style.opacity = '1'; // Make video visible
                overlay.classList.add('hidden'); // Hide overlay
            }
        };

        if (video) {
            video.addEventListener('canplay', handleCanPlay);
        }

        return () => {
            if (video) {
                video.removeEventListener('canplay', handleCanPlay);
            }
        };
    }, []);

    return (
        <div className="banner">
            <div className="banner-video-wrapper">
                <video ref={videoRef} className="banner-video" autoPlay muted loop>
                
                    {/* <source src="https://static.videezy.com/system/resources/previews/000/044/526/original/smoke-2.mp4" type="video/mp4" /> */}
                    <source src="https://static.videezy.com/system/resources/previews/000/009/212/original/4k0413.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div ref={overlayRef} className="banner-overlay"></div>
            </div>
            <div className="banner-container">
                <div className="banner-left">
                    <div className="banner-sub">
                        <h2>tattoos</h2>
                        <p>estd. 2006</p>
                    </div>
                    <div className="banner-title">
                        <p className="banner-title-name">ty-<span className="logo-red">m</span>e tattoo</p>
                        <p className="banner-title-subname">Studio & Academy</p>
                    </div>
                    <p className="banner-works">Tattoos | Piercings | Tattoo Training</p>
                    <div className="btn-container">
                        <button className="banner-btn">book appointment</button>
                    </div>
                </div>
                <div className="banner-right">
                    <img className="banner-image" src="https://66c5425d3a99369f26d2402e--glittering-cat-12e859.netlify.app/IMG_2120.jpg" alt="artist" />
                </div>
            </div>
        </div>
    );
}